import React, { useState, useEffect } from 'react';
import { Wifi, Users, MapPin, TrendingUp, Shield, Zap, CheckCircle, ArrowRight, Star, Phone, Globe, IndianRupee, Network, Smartphone, Building2 } from 'lucide-react';

export default function PMWANILPage() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const testimonials = [
    {
      text: "मैंने अपने घर पर PM-WANI मशीन लगवाई है। अब हर महीने ₹1700 एक्स्ट्रा कमाई हो जाती है!",
      author: "संजय शर्मा",
      location: "फतेहपुर, उत्तर प्रदेश"
    },
    {
      text: "हमारे गॉंव में सभी ग्रामवासियो एवं सभी छात्रों को फ्री हाईस्पीड वाई-फाई मिलता है। इससे ऑनलाइन कॉल, वर्क , ऑनलाइन क्लासेस और पढ़ाई में बहुत मदद मिली है।",
      author: "सुनील श्रीवास्तवा",
      location: "गोरखपुर, उत्तर प्रदेश"
    },
    {
      text: "एम्स रायबरेली में फ्री हाई-स्पीड वाई-फाई मिलने से हमें बहुत खुशी हुई। यहां नेटवर्क की समस्या रहती थी, लेकिन इस सुविधा से मरीजों और उनके परिजनों को ऑनलाइन पेमेंट करने, अपॉइंटमेंट नंबर लगाने और अन्य ज़रूरी कार्यों में बड़ी सहायता मिलेगी।",
      author: "नवीन निर्मल",
      location: "परिजन, एम्स रायबरेली, उत्तर प्रदेश"
    }
  ];

  const benefits = [
    { icon: Building2, text: "Start Your Own Wi-Fi Business with Minimum Investment" },
    { icon: IndianRupee, text: "Earn Passive Income from Every User" },
    { icon: Zap, text: "Easy Installation, No Technical Background Required" },
    { icon: CheckCircle, text: "No Government License Needed" },
    { icon: TrendingUp, text: "Transparent Billing and Reporting via PDOA" },
    { icon: Network, text: "Your Wi-Fi Network Serves 100–200+ Meter Radius" },
    { icon: Users, text: "Serve Hundreds of Daily Users" }
  ];

  const eligibleUsers = [
    "Retail Shop Owners", "Cyber Cafés", "Schools & Colleges", 
    "Bus Stops & Railway Stations", "Gram Panchayats & CSCs",
    "Apartment Complexes", "Tea Shops & Grocery Stores"
  ];

  const handleFormSubmit = () => {
    window.open('https://forms.gle/qxzYMc7wcbw4fiD26', '_blank');
  };

  const handlePayment = () => {
    window.open('https://payu.in/invoice/278E96047FC7107B0BB8C150295338497E7188F585220534625FAFB9C5BA7A91/ADD0FFED2C75B4FAFA82334983370B8F', '_blank');
  };

  return (
    <div className="min-h-screen pt-12 bg-gradient-to-br from-blue-50 via-white to-orange-50">
      {/* Hero Section */}
 <section className="relative overflow-hidden bg-gradient-to-r from-blue-600 via-indigo-700 to-purple-800">
  <div className="absolute inset-0 bg-black/20"></div>
  <div className="relative container mx-auto px-4 pt-20 pb-10">
    <div className={`text-center transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
      <div className="flex justify-center mb-6">
        <div className="p-4 bg-white/10 rounded-full backdrop-blur-sm">
          <Wifi className="w-16 h-16 text-white" />
        </div>
      </div>
      <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
        PM-WANI
        <span className="block text-3xl md:text-4xl text-orange-300 font-normal mt-2">
          Powering India's Public Wi-Fi Revolution
        </span>
      </h1>
      <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-4xl mx-auto leading-relaxed">
        Welcome to the Future of Internet Access – Fast, Affordable, and for Everyone
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12"> {/* Added mb-12 for spacing */}
        <button 
          onClick={handleFormSubmit}
          className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-2"
        >
          <ArrowRight className="w-5 h-5" />
          Start Your PDO Journey
        </button>
        <button 
          onClick={handlePayment}
          className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-all duration-300 backdrop-blur-sm border border-white/20 flex items-center gap-2"
        >
          <IndianRupee className="w-5 h-5" />
          Complete Payment
        </button>
      </div>
    </div>
  </div>
  {/* Changed the wave positioning */}
  <div className="relative z-10"> {/* Added relative and z-10 */}
    <svg viewBox="0 0 1200 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
      <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"/>
      <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"/>
      <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="currentColor"/>
    </svg>
  </div>
</section>

      {/* What is PM-WANI Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">🌐 What is PM-WANI?</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-orange-500 mx-auto"></div>
          </div>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              PM-WANI is a national-level framework designed to provide broadband internet access through public Wi-Fi hotspots. 
              The goal is simple yet powerful: make internet connectivity accessible, affordable, and universal.
            </p>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-6 rounded-xl">
                <Globe className="w-12 h-12 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold text-gray-800 mb-3">No Bureaucratic Hurdles</h3>
                <p className="text-gray-600">No license, no spectrum fees, and no complicated procedures. Start your Wi-Fi business today!</p>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-red-100 p-6 rounded-xl">
                <TrendingUp className="w-12 h-12 text-orange-600 mb-4" />
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Revenue Opportunity</h3>
                <p className="text-gray-600">Whether you're a rural entrepreneur or city-based business, earn revenue while building Digital India.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PM-WANI Ecosystem */}
      <section className="py-16 bg-gradient-to-r from-gray-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">🧩 PM-WANI Ecosystem</h2>
            <p className="text-lg text-gray-600">Key Players in the Framework</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <Building2 className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-center mb-3">Public Data Office (PDO)</h3>
              <p className="text-gray-600 text-center">Any individual or business that sets up and manages a public Wi-Fi hotspot as direct providers of internet access.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <Network className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-center mb-3">PDOA</h3>
              <p className="text-gray-600 text-center">Aggregates multiple PDOs, handles backend operations like user authentication, accounting, and compliance.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <Shield className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-semibold text-center mb-3">Central Registry</h3>
              <p className="text-gray-600 text-center">Managed by C-DoT, maintains a secure database of all ecosystem participants and ensures regulatory alignment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why PM-WANI Matters */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">🚀 Why PM-WANI Matters</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <Globe className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-semibold mb-4">🌍 Expanding Digital India's Reach</h3>
              <p className="text-gray-600">Millions of Indians still lack reliable internet access. PM-WANI bridges this gap by delivering affordable broadband to underserved areas.</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <TrendingUp className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-semibold mb-4">💼 New Business Opportunities</h3>
              <p className="text-gray-600">Anyone—from a tea stall owner to a school administrator—can set up a public Wi-Fi hotspot and earn consistent monthly income.</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <Shield className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-semibold mb-4">🔐 Secure & Scalable</h3>
              <p className="text-gray-600">Built on modern, decentralized architecture with data privacy, security, and compliance at its core.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gradient-to-br from-orange-50 to-red-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">📊 Benefits of Becoming a PM-WANI PDO</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
                <benefit.icon className="w-12 h-12 text-orange-600 mb-4" />
                <p className="text-gray-700 font-medium">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How Users Connect */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">📲 How Users Connect to PM-WANI Wi-Fi</h2>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { step: "1", icon: Wifi, text: "Turn on Wi-Fi and scan for nearby PM-WANI hotspots" },
                { step: "2", icon: Smartphone, text: "Connect and get redirected to captive portal or PM-WANI app" },
                { step: "3", icon: Phone, text: "Register or login using mobile OTP" },
                { step: "4", icon: Globe, text: "Choose a free or paid plan and start browsing securely" }
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 mx-auto relative">
                    <item.icon className="w-8 h-8 text-blue-600" />
                    <span className="absolute -top-2 -right-2 w-6 h-6 bg-orange-500 text-white rounded-full text-sm font-bold flex items-center justify-center">
                      {item.step}
                    </span>
                  </div>
                  <p className="text-gray-600">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Who Can Join */}
      <section className="py-16 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">📈 Who Can Join PM-WANI?</h2>
            <p className="text-lg text-gray-600">Anyone with a broadband connection and a small business space can participate</p>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {eligibleUsers.map((user, index) => (
                <div key={index} className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex items-center gap-3">
                  <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{user}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">🛠️ We Help You Set Up Everything</h2>
            <p className="text-lg text-gray-600">Our company provides end-to-end support for PM-WANI deployment</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { icon: Wifi, title: "Smart Wi-Fi Router Installation", desc: "Professional installation and setup" },
              { icon: CheckCircle, title: "PDO Registration & Compliance", desc: "Complete paperwork and registration" },
              { icon: Smartphone, title: "App Integration", desc: "Seamless app connectivity" },
              { icon: TrendingUp, title: "Daily Earnings Reports", desc: "Real-time dashboards and analytics" },
              { icon: Phone, title: "Technical Support", desc: "24/7 troubleshooting assistance" },
              { icon: Shield, title: "Security & Monitoring", desc: "Continuous network monitoring" }
            ].map((service, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-blue-50 p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
                <service.icon className="w-12 h-12 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gradient-to-r from-indigo-600 to-purple-700">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">💬 Real Success Stories</h2>
            <p className="text-xl text-indigo-200">Testimonials from PM-WANI Partners</p>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <div className="text-center">
                <div className="flex justify-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
                  ))}
                </div>
                <blockquote className="text-lg md:text-xl text-white mb-6 italic leading-relaxed">
                  "{testimonials[currentTestimonial].text}"
                </blockquote>
                <div className="text-indigo-200">
                  <p className="font-semibold text-lg">{testimonials[currentTestimonial].author}</p>
                  <p className="text-sm">{testimonials[currentTestimonial].location}</p>
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-6 gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentTestimonial ? 'bg-white' : 'bg-white/30'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-red-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            📞 Ready to Be a Part of the Wi-Fi Revolution?
          </h2>
          <p className="text-xl text-orange-100 mb-8 max-w-3xl mx-auto">
            Start your PM-WANI journey today and help connect your community while growing your income.
            Together, Let's Build a Connected, Digitally Empowered India!
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button 
              onClick={handleFormSubmit}
              className="px-10 py-4 bg-white text-orange-600 font-bold text-lg rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-3"
            >
              <ArrowRight className="w-6 h-6" />
              Apply Now - Start Your PDO
            </button>
            <button 
              onClick={handlePayment}
              className="px-10 py-4 bg-orange-700 hover:bg-orange-800 text-white font-bold text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-3"
            >
              <IndianRupee className="w-6 h-6" />
              Complete Payment
            </button>
          </div>
          <div className="mt-8 text-orange-100">
            <p className="text-sm">Fill the form first, then proceed with payment</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <Wifi className="w-12 h-12 text-blue-400" />
            </div>
            <h3 className="text-2xl font-bold mb-4">PM-WANI</h3>
            <p className="text-gray-400 mb-6">Empowering Digital India, One Hotspot at a Time</p>
            <div className="flex justify-center gap-6 mb-8">
              <span className="px-4 py-2 bg-blue-600 rounded-full text-sm">#PMWANI</span>
              <span className="px-4 py-2 bg-orange-600 rounded-full text-sm">#DigitalIndia</span>
              <span className="px-4 py-2 bg-green-600 rounded-full text-sm">#WiFiForAll</span>
            </div>
            <div className="border-t border-gray-800 pt-6">
              <p className="text-gray-500 text-sm">
                © 2025 PM-WANI Initiative. Building a Connected India.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}